<template>
    <div id="row" class="d-flex flex-column align-items-left">
      <div class="row1 d-flex flex-rows justify-content-between align-items-center">
        <div class="lg1">
          <span class="title">{{title.lg1}}</span> <span class="subtitle">{{subtitle.lg1}}</span>
        </div>
        <div class="price float-right">{{price}}</div>
      </div>
      <div class="row2 lg2">
        <span class="title">{{title.lg2}}</span > <span class="subtitle">{{subtitle.lg2}}</span>
        <div class="price float-right">{{ freeOfCharge }}</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'NovotelRatesHorizontalV1RatesRow',
  props: {
    servicesLg1: Object,
    servicesLg2: Object
  },
  computed: {
    title () {
      return {lg1: this.servicesLg1.label_value, lg2: this.servicesLg2.label_value}
    },
    subtitle () {
      return {lg1: this.servicesLg1.sub_label, lg2: this.servicesLg2.sub_label}
    },
    price () {
      return this.servicesLg1.msr_value
    },
    price2 () {
      return this.servicesLg2.msr_value
    },
    freeOfCharge () {
      if (this.price === this.price2) {
        return ''
      } else {
        return this.price2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_novotel.scss";

#row {
  width: 100%;
  @include heightPercent(120);
  border-image-source: url(../assets/novotel_Séparation_904x9px.png);
  border-image-slice: 9 0 0 0 fill;
  border-image-width: 9px 0px 0px 0px;
  border-image-repeat: repeat repeat;

  .row1 {
    margin-top: 0.3vh;
    .lg1 {
      max-height: 2rem;
      overflow: hidden;

      .title {
        font-family: "Novotype-Medium";
        text-transform: uppercase;
        @include fontSize(35);
      }

      .subtitle {
        font-family: "National-Medium";
        @include fontSize(30);
      }
    }

    .price {
      font-family: "National-Medium";
      @include fontSize(49);
      color: $darkBlue;
      white-space: nowrap;
    }
  }

  .row2 {
    margin-top: -0.5em;
    max-height: 2em;
    overflow: hidden;

    .title {
      font-family: "Novotype-Regular";
      text-transform: uppercase;
      @include fontSize(29);
    }

    .subtitle {
      font-family: "National-Medium";
      @include fontSize(29);
    }

    .price {
      font-family: "National-Medium";
      @include fontSize(32);
      white-space: nowrap;
      margin-top: -0.2em;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/novotel/rates/horizontal/v1/services/rowServices.vue